import { watch } from 'vue'

import { useCurrentUserStore } from '@common/current-user-layer/stores/currentUser.store'
import { useLocationStore } from '@common/location-layer/store/location.store'

import type { NuxtApp } from 'nuxt/app'

const DEFAULT_LOCALE = 'en'

export const createLocalePreferencePlugin = () => {
  return (nuxtApp: NuxtApp) => {
    const currentUserStore = useCurrentUserStore()
    const locationStore = useLocationStore()
    const i18n = nuxtApp.$i18n as ReturnType<typeof useI18n> | undefined
    if (!i18n) return

    const supportedLocales = new Set(((i18n.localeCodes?.value ?? i18n.localeCodes) as string[]) ?? [])

    const resolveLocale = (): string => {
      const userPref = currentUserStore.profile?.languagePreference
      if (userPref && supportedLocales.has(userPref)) return userPref

      const builderPref = locationStore.languagePreferenceBuilder
      if (builderPref && supportedLocales.has(builderPref)) return builderPref

      return DEFAULT_LOCALE
    }

    const applyLocale = () => {
      const target = resolveLocale()
      const current = typeof i18n.locale === 'string' ? i18n.locale : i18n.locale?.value
      if (target !== current) {
        void i18n.setLocale?.(target)
      }
    }

    applyLocale()

    watch(
      () => currentUserStore.profile?.languagePreference,
      () => applyLocale()
    )

    watch(
      () => locationStore.languagePreferenceBuilder,
      () => applyLocale()
    )
  }
}
